import type { ActionReducerMapBuilder, AsyncThunk } from "@reduxjs/toolkit"

import { type ProposalsState } from "./proposals.types.ts"

type BooleanKeys<T> = {
  [K in keyof T]: T[K] extends boolean ? K : never
}[keyof T]

const addFetchingCases = <T>(
  builder: ActionReducerMapBuilder<ProposalsState>,
  thunk: AsyncThunk<T, any, any>,
  key: BooleanKeys<ProposalsState> = "saveFetching"
) => {
  builder
    .addCase(thunk.pending, (state) => {
      state[key] = true
    })
    .addCase(thunk.fulfilled, (state) => {
      state[key] = false
    })
    .addCase(thunk.rejected, (state) => {
      state[key] = false
    })
}

export { addFetchingCases }
